import { z } from 'zod';

/**
 * トップバナー編集フォームのバリデーションスキーマ
 *
 * @property title - バナー名（必須）
 * @property transitionUrl - 遷移先URL（必須、URL形式）
 * @property restrictedToApp - バナー遷移先（必須、'true': アプリ内部, 'false': アプリ外部）
 * @property status - ステータス（必須、0: 表示, 1: 非表示）
 * @property image - バナー画像（任意、編集時は既存画像を維持可能）
 * @property groupId - グループID（任意）
 * @property targetUserType - 配信対象（必須、'everyone': すべて（従業員＋家族）, 'employees_only': 従業員のみ）
 */
export const editTopBannerSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, 'バナー名を入力してください')
    .max(40, 'バナー名は40文字以内で入力してください'),
  transitionUrl: z
    .string()
    .trim()
    .min(1, '遷移先URLを入力してください')
    .url('有効なURLを入力してください'),
  restrictedToApp: z.union([z.literal('true'), z.literal('false')]),
  status: z.union([z.literal('0'), z.literal('1')]),
  image: z
    .instanceof(File, { message: 'バナー画像をアップロードしてください' })
    .refine(file => ['image/jpeg', 'image/png'].includes(file.type), {
      message: '画像はJPEGまたはPNG形式である必要があります',
    })
    .optional(),
  groupId: z.string().trim().optional(),
  targetUserType: z.union([z.literal('everyone'), z.literal('employees_only')]),
});

/**
 * トップバナー編集フォームのフィールド値の型
 */
export type EditTopBannerFormFieldValues = z.infer<typeof editTopBannerSchema>;
